import { TicketStatus } from '@nimey/podcast-global-entity';
import { useTranslation } from 'react-i18next';

export const TicketStatusLabel = ({status}: {status: TicketStatus}) => {
  const { t } = useTranslation('help');
  return <>{t('ticket.status.' + status)}</>
}